import { motion } from "framer-motion";

export const ApplicationRequirements = () => {

    return (
        <>
            <h1 className="section-headers">STUDING ABROAD REQUIREMENTS</h1>
            <div className="requirements">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 2 }}
                    viewport={{ once: false, amount: 0.1 }}
                    className="requirement card">
                    <h3>PERSONAL INFORMATION</h3>
                    <hr />
                    <p>You need to know and have your accurate personal information such as fullnames, address, email or phone number or contact informations and also your relative informations . These will help you when applying for universities or colleges</p>
                
                </motion.div>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 2 }}
                    viewport={{ once: false, amount: 0.1 }}
                    className="requirement card">
                    <h3>ELIGIBILITY</h3>
                    <hr />
                    <ul>
                        <li className="note">For PhD programs, applicants must have completed a recognized master's degree program.</li>
                        <li className="note">For BACHELOR'S DEGREE programs, applicants must have completed a recognized advanced secondary school or diploma.</li>
                        <li className="note">For MASTERS DEGREE programs, applicants must have completed a recognized bachelor's degree.</li>
                        <li className="note">For CERTIFICATE and  DIPLOMA programs, applicants must have completed a recognized secondary school program or equivalent.</li> 
                        <p>for more information contact us</p>
                        {/* // <li>For short-term programs, applicants must have completed a recognized secondary school program or equivalent.</li>
                        // <li>For language programs, applicants must have completed a recognized secondary school program or equivalent.</li>
                        // <li>For research programs, applicants must have completed a recognized secondary school program or equivalent.</li>
                        // <li>For internship programs, applicants must have completed a recognized secondary school program or equivalent.</li>  */}
                    </ul>
                </motion.div>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 2 }}
                    viewport={{ once: false, amount: 0.1 }}
                    className="requirement card">
                    <h3>DOCUMENTS</h3>
                    <hr />
                    <ul>
                        <li className="note">Valid passport</li>
                        <li className="note">Form Four & Form Six / Diploma / Degree certificates and transcripts</li>
                        <li className="note">Motivation Letter or Study Plan</li>
                        <li className="note">Medical Examination Form</li>
                        <li className="note">Police Clearance Certificate (needed later for the visa)</li>
                        <li className="note">Passport-size photos (white background)</li>
                    </ul>
                </motion.div>
                {/* <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 2 }}
                    viewport={{ once: false, amount: 0.1 }}
                    className="requirement card">
                    <h3>APPLICATION PROCESS</h3>
                    <hr />
                    <p> For simplicity,  apply through our <a className="aisNote" href="/aas/apply" target="_blank"><em>AAS (ARTHUR APPLICATION SYSTEM)</em></a>  system,  This system will make your application be delivered easily, And Our  team will  closer help you to archive the best university you wish.</p>
                    <p>Not Only That. You will also be able to easily track your application progress status such as either not submited, submited, received, rejected, approved, selected and much more informations</p>
                </motion.div> */}

            </div>
        </>
    )
}